import { getRandom, getRangeValue, rangeColorToHsl } from "tsparticles-engine";
export function initParticle(particle) {
    const rollOpt = particle.options.roll;
    if (!rollOpt?.enable) {
        particle.roll = {
            enable: false,
            horizontal: false,
            vertical: false,
            angle: 0,
            speed: 0,
        };
        return;
    }
    particle.roll = {
        enable: rollOpt.enable,
        horizontal: rollOpt.mode === "horizontal" || rollOpt.mode === "both",
        vertical: rollOpt.mode === "vertical" || rollOpt.mode === "both",
        angle: getRandom() * Math.PI * 2,
        speed: getRangeValue(rollOpt.speed) / 360,
    };
    if (rollOpt.backColor) {
        particle.backColor = rangeColorToHsl(rollOpt.backColor);
    }
    else if (rollOpt.darken.enable && rollOpt.enlighten.enable) {
        const alterType = getRandom() >= 0.5 ? "darken" : "enlighten";
        particle.roll.alter = {
            type: alterType,
            value: getRangeValue(alterType === "darken" ? rollOpt.darken.value : rollOpt.enlighten.value),
        };
    }
    else if (rollOpt.darken.enable) {
        particle.roll.alter = {
            type: "darken",
            value: getRangeValue(rollOpt.darken.value),
        };
    }
    else if (rollOpt.enlighten.enable) {
        particle.roll.alter = {
            type: "enlighten",
            value: getRangeValue(rollOpt.enlighten.value),
        };
    }
}
export function updateRoll(particle, delta) {
    const roll = particle.options.roll, data = particle.roll;
    if (!data || !roll?.enable) {
        return;
    }
    const speed = data.speed * delta.factor, max = 2 * Math.PI;
    data.angle += speed;
    if (data.angle > max) {
        data.angle -= max;
    }
}
